import { Typography } from '@mui/material'
import React, { memo, useCallback } from 'react'
import tw from 'twin.macro'
import { CircleRightMajor } from '@shopify/polaris-icons'
import BGCIcon from 'src/assets/icons/bgc.svg'
import { CollectDataStepIndex } from 'src/components/client/CollectDataStepIndex'
import { useSelector } from 'react-redux'
import { getCurrentCollectDataStep } from 'src/selectors/collectData'
import { useYardstik } from 'src/hooks/useYardstik'
import { BGCCollectDataStep } from 'src/interfaces/collectData'
import { Button } from '../shared/Button'

interface Props {
  onOpenManualUpload?: () => void
}

const BGCYardstikComponent = ({ onOpenManualUpload }: Props) => {
  const currentStep = useSelector(getCurrentCollectDataStep) as BGCCollectDataStep

  const { isYardstikLoading, startYardstik, YardstikView } = useYardstik()

  const showYardstik = useCallback(() => {
    startYardstik(currentStep.id)
  }, [currentStep.id])

  return (
    <>
      <div css={tw`h-full w-full flex flex-col justify-between`}>
        <div>
          <div
            css={tw`w-11 h-11 flex justify-center items-center [border-radius: 22px] bg-shades-100 mt-2 mb-4`}
          >
            <img src={BGCIcon} />
          </div>
          <CollectDataStepIndex stepId={currentStep.id} />
          <Typography css={tw`mb-2 mt-2`} variant="h2">
            Background Check & Motor Vehicle Record
          </Typography>
          <Typography css={tw`mb-4 text-shades-400`}>
            To conduct your Background Check & Motor Vehicle Record report we'll use our industry
            leading partner, Yardstik. Tap “Proceed with Yardstik” button below to begin.
          </Typography>
          {onOpenManualUpload ? (
            <div css={tw`rounded-2xl p-4 bg-shades-0 mt-6`}>
              <Typography css={tw`mb-1`} variant="h4">
                Already have Background Check & Motor Vehicle Report documents?
              </Typography>
              <Typography css={tw`mb-4 text-shades-400`}>
                Please upload your documents to expedite the process.
              </Typography>
              <Button
                leftIcon={<CircleRightMajor css={tw`fill-primary-500`} width={20} />}
                className={tw`w-full`}
                color="light"
                onClick={onOpenManualUpload}
              >
                Tap to upload documents
              </Button>
            </div>
          ) : null}
        </div>
        <Button className={tw`w-full`} loading={isYardstikLoading} onClick={showYardstik}>
          Proceed with Yardstik
        </Button>
      </div>
      <YardstikView />
    </>
  )
}

export const BGCYardstik = memo(BGCYardstikComponent)
